// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RichTextSection_wrapper__pvLYR"};